<template>
  <div>
    <el-steps :active="1" simple style="margin-top: 40px">
      <el-step title="考试文件" icon="el-icon-document"></el-step>
      <el-step title="考生承诺" icon="el-icon-upload"></el-step>
      <el-step title="资料登记" icon="el-icon-edit"></el-step>
      <el-step title="报考信息" icon="el-icon-message"></el-step>
      <el-step title="缴费" icon="el-icon-money"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  data() {},
  methods: {
   
  },
};
</script>

<style>
</style>